var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowPolyGridHaikei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1280 320",
    width: 1280,
    height: 320,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.1 182.3L830.3 139.7L708.1 133.7Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.1 182.3L857.3 192.3L830.3 139.7Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.1 182.3L839.3 320L857.3 192.3Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.1 182.3L689.1 320L839.3 320Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.3 139.7L726.1 0L708.1 133.7Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.1 133.7L593.9 74.7L697.1 182.3Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.6 117.7L827.3 0L830.3 139.7Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.3 139.7L827.3 0L726.1 0Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.1 0L593.9 74.7L708.1 133.7Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.1 182.3L559.9 217.3L689.1 320Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.6 214.3L960.6 117.7L857.3 192.3Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.3 192.3L960.6 117.7L830.3 139.7Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.9 74.7L559.9 217.3L697.1 182.3Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.3 320L986.6 214.3L857.3 192.3Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.9 217.3L581.9 320L689.1 320Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.6 117.7L1000.6 0L827.3 0Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.8 110.7L1000.6 0L960.6 117.7Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.1 0L533.9 0L593.9 74.7Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7 127.7L392.7 212.3L559.9 217.3Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.3 320L1019.6 320L986.6 214.3Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.6 214.3L1146.8 110.7L960.6 117.7Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7 127.7L559.9 217.3L593.9 74.7Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.9 217.3L392.7 320L581.9 320Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.9 0L388.7 127.7L593.9 74.7Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.8 212.3L1146.8 110.7L986.6 214.3Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.6 320L1167.8 212.3L986.6 214.3Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.9 0L403.7 0L388.7 127.7Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.4 320L392.7 320L392.7 212.3Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.7 212.3L392.7 320L559.9 217.3Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.8 110.7L1137.8 0L1000.6 0Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 0L1137.8 0L1146.8 110.7Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.6 320L1167.8 320L1167.8 212.3Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.7 0L306.4 96.7L388.7 127.7Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7 127.7L292.4 183.3L392.7 212.3Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4 96.7L292.4 183.3L388.7 127.7Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.7 0L310.4 0L306.4 96.7Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4 96.7L152.2 113.7L292.4 183.3Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4 183.3L283.4 320L392.7 212.3Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 230.3L1280 130.7L1167.8 212.3Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.8 212.3L1280 130.7L1146.8 110.7Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.8 320L1280 230.3L1167.8 212.3Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.8 320L1280 320L1280 230.3Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 130.7L1280 0L1146.8 110.7Z",
    fill: "#205a7a",
    stroke: "#205a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2 0L152.2 113.7L306.4 96.7Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4 183.3L150.2 320L283.4 320Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 191.3L150.2 320L292.4 183.3Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.4 0L136.2 0L306.4 96.7Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 113.7L104.2 191.3L292.4 183.3Z",
    fill: "#205a7a",
    stroke: "#205a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 201.3L104.2 191.3L0 126.7Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 126.7L104.2 191.3L152.2 113.7Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 191.3L0 320L150.2 320Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2 0L0 126.7L152.2 113.7Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 201.3L0 320L104.2 191.3Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2 0L0 0L0 126.7Z",
    fill: "#15384f",
    stroke: "#15384f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPolyGridHaikei);
export default __webpack_public_path__ + "static/media/low-poly-grid-haikei.c37e037e4b96432d774291767c23a99b.svg";
export { ForwardRef as ReactComponent };